import {registerLocaleData} from '@angular/common';
import pl from '@angular/common/locales/pl';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgModule, provideAppInitializer} from '@angular/core';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {NgxsModule} from '@ngxs/store';
import {NgxsRouterPluginModule} from '@ngxs/router-plugin';
import {NZ_DATE_CONFIG, NZ_I18N, pl_PL} from 'ng-zorro-antd/i18n';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {CoreModule} from './modules/core';
import {SharedModule} from './modules/shared';
import {NgxsReduxDevtoolsPluginModule} from '@ngxs/devtools-plugin';
import {rootState} from './state/root.state';
import {rootService} from './services/root.service';
import {environment} from '../environments/environment';
import {NgxMaskConfig, provideEnvironmentNgxMask} from 'ngx-mask';
import {HttpErrorInterceptor} from './interceptors/http-error.interceptor';
import {LoaderInterceptor} from './interceptors/loader.interceptor';
import {NgxsSelectSnapshotModule} from '@ngxs-labs/select-snapshot';
import {ValidationModule} from './modules/validation/validation.module';
import {labelsInitializer, TranslationLoader} from './resolvers/translation.loader';
import {HttpParameterInterceptor} from './interceptors/http-parameter.interceptor';
import {CookieService} from 'ngx-cookie-service';

registerLocaleData(pl);

const maskOptions: Partial<NgxMaskConfig> | (() => Partial<NgxMaskConfig>) = {};

@NgModule({
    declarations: [AppComponent],
    bootstrap: [AppComponent],
    imports: [
        // vendor modules
        BrowserModule,
        BrowserAnimationsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useExisting: TranslationLoader,
            },
        }),
        NgxsModule.forRoot(rootState, {
            developmentMode: !environment.production,
            selectorOptions: {
                suppressErrors: true,
            },
        }),
        NgxsReduxDevtoolsPluginModule.forRoot(),
        NgxsRouterPluginModule.forRoot(),
        NgxsSelectSnapshotModule.forRoot(),
        // project modules
        SharedModule,
        AppRoutingModule,
        CoreModule,
        ValidationModule.forRoot(),
    ],
    providers: [
        rootService,
        {provide: NZ_I18N, useValue: pl_PL},
        {provide: NZ_DATE_CONFIG, useValue: {firstDayOfWeek: 1}},
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpErrorInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LoaderInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpParameterInterceptor,
            multi: true,
        },
        provideAppInitializer(labelsInitializer),
        provideEnvironmentNgxMask(maskOptions),
        provideHttpClient(withInterceptorsFromDi()),
        CookieService,
    ],
})
export class AppModule {}
